import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ToastDialog from "../dialogs/ToastDialog";
import { API_GET_HOME_INFO } from "../modals/Constants";
import { getStorage, setStorage } from "../modals/Storage";
import ContainerV1Modal from "../containerModals/ContainerV1/modal";
import ContainerV2Modal from "../containerModals/ContainerV2/modal";
import ContainerV3Modal from "../containerModals/ContainerV3/modal";
import ContainerV4Modal from "../containerModals/ContainerV4/modal";
import ContainerV5Modal from "../containerModals/ContainerV5/modal";
import ContainerV6Modal from "../containerModals/ContainerV6/modal";
import ContainerV7Modal from "../containerModals/ContainerV7/modal";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import general from "../css/General.module.css";
import HeaderView from "../other-components/HeaderView/view";
import CategoriesView from "../other-components/CategoryView/view";
import FooterView from "../other-components/FooterView/view";
import SpecialMessageView from "../other-components/SpecialMessageView/view";


function Home() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const delay = 2500;

  const [pageConst, setConstants] = useState({
    showHeadSearch: true,
    toastMessage: "",
    toastDialogShow: false,
    isShowFooter: true,
    isLoadingShow: false,
    sliderImages: [],
    recordList: [],
    productsList: [],
    homeUI: [],
  });

  const updateToastDialogState = (data, msg) => {
    setConstants((previousState) => {
      return { ...previousState, toastDialogShow: data };
    });

    setConstants((previousState) => {
      return { ...previousState, toastMessage: msg };
    });
  };

  const updateUI = (data) => {
    const containerComponents = {
      "c-1": ContainerV1Modal,
      "c-2": ContainerV2Modal,
      "c-3": ContainerV3Modal,
      "c-4": ContainerV4Modal,
      "c-5": ContainerV5Modal,
      "c-6": ContainerV6Modal,
      "c-7": ContainerV7Modal
    };

    const tempData = data
      .filter((item) => containerComponents[item.class] && item.items.length > 0)
      .map((item, i) => {
        const Container = containerComponents[item.class];
        let allowSpace = true;

        if (i == 0 && item.class == "c-6") {
          allowSpace = false;
        }

        return (
          <Container
            key={`${item.class}-${i}`}
            data={item.items}
            title={item.title}
            description={item.description}
            spaceAbove={allowSpace}
          />
        );
      });

    setConstants((prev) => ({
      ...prev,
      homeUI: tempData,
    }));
  };

  function initializeHome() {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if (data.status_code === "success") {
          setStorage("app_special_message", data.special_message);

          updateUI(data.containers);
          setStorage("app_cart_items", data.total_cart_records);
          setStorage("app_whatsapp_support_url", data.whatsapp_support_url);

          if (data.categories.length > 0) {
            setStorage("categories", JSON.stringify(data.categories));
          }

          setIsDataLoaded(true);
        }
      } catch (error) {
        setLoading(false);
      }
    }

    if (!isDataLoaded) {
      setLoading(true);
      const formData = { ACCOUNT_ID: getStorage("accountID") };
      requestAPI(API_GET_HOME_INFO, formData);
    }
  }

  // useEffect(() => {
  //   loadHomeScreenData();
  // }, [pageConst.sliderImages, slideShowIndex]);

  useEffect(() => {
    initializeHome();
  }, []);

  return (
    <div className={[general.appView]}>
      <ToastDialog
        intentData={pageConst}
        updateState={updateToastDialogState}
      />

      <LoadingDialog isOpen={loading} />

      <div className={[general.appChildView]}>
        <SpecialMessageView />
        <HeaderView categories={pageConst.categoryList} />
        <CategoriesView key="categories" />

        <div className={[general.appHomeContentsView]}>
          {pageConst.homeUI}
        </div>

        <FooterView />
      </div>
    </div>
  );
}

export default Home;
